module.exports = __webpack_public_path__ + "7f5aa932d82b79e8ea67b935257a5c6d.pdf";